/**
 * 最後の 4 文字を取得する
 * @param str
 * @returns
 */
export function getLastFourCharacters(str: string): number {
  return Number(str.substring(str.length - 4));
}

/**
 * 似た文字を比較する
 * @param str1
 * @param str2
 * @returns true/false
 */
export function compareSimilarCharacters(str1: string, str2: string): boolean {
  /** 比較を容易にするために両方の文字列を配列に変換します */
  const arr1 = str1.split('');
  const arr2 = str2.split('');

  /** 順序が比較に影響しないように配列を並べ替える */
  arr1.sort();
  arr2.sort();

  /** 最初の文字列の各文字を反復処理します。*/
  for (let char of arr1) {
    /** 2番目の文字列に文字が存在するかどうかを確認します */
    if (arr2.includes(char)) {
      /** 存在する場合は、重複一致を避けるために両方の配列から文字を削除します。*/
      arr2.splice(arr2.indexOf(char), 1);
    } else {
      /** 2 番目の文字列に文字が存在しない場合は false を返します */
      return false;
    }
  }

  /** 最初の文字列のすべての文字が 2 番目の文字列で見つかった場合は、true を返します。*/
  return true;
}
